export interface ComicChapter {
  id: string;
  title: string;
  updateDate: string;
  isNew: boolean;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  category: string;
  categorySlug: string;
  tags: string[];
  rating: number;
  views: number;
  status: '连载中' | '已完结';
  updateDate: string;
  chapters: ComicChapter[];
  totalChapters: number;
  isHot: boolean;
  isNew: boolean;
  isRecommended: boolean;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '恋爱', slug: 'romance' },
  { name: '奇幻', slug: 'fantasy' },
  { name: '动作', slug: 'action' },
  { name: '剧情', slug: 'drama' },
  { name: '悬疑', slug: 'thriller' },
  { name: '搞笑', slug: 'comedy' },
  { name: '都市', slug: 'urban' },
  { name: '古风', slug: 'historical' },
];

export const comics: Comic[] = [
  {
    id: 'comic-01',
    title: '公爵夫人的秘密',
    author: '金荷娜',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20duchess%20in%20a%20luxurious%20historical%20gown%2C%20soft%20warm%20lighting%2C%20romantic%20atmosphere%2C%20detailed%20fabric%20textures%2C%20castle%20interior%20background%2C%20anime%20style%20art%2C%20warm%20amber%20and%20rose%20color%20palette&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '在贵族社会中隐藏身份的公爵夫人，与神秘陌生男子之间展开的禁忌爱情故事。她必须在家族荣誉和真爱之间做出选择，每一步都暗藏危机。',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '古风', '宫廷'],
    rating: 9.6,
    views: 1285000,
    status: '连载中',
    updateDate: '2026-08-04',
    chapters: [
      { id: 'ch-01-001', title: '第1话 命运的交汇', updateDate: '2026-01-15', isNew: false },
      { id: 'ch-01-002', title: '第2话 隐藏的真身', updateDate: '2026-01-22', isNew: false },
      { id: 'ch-01-078', title: '第78话 最后的抉择', updateDate: '2026-08-04', isNew: true },
    ],
    totalChapters: 78,
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-02',
    title: '剑之帝王',
    author: '朴志成',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20illustration%20of%20a%20powerful%20swordsman%20in%20martial%20arts%20attire%2C%20dynamic%20pose%20with%20glowing%20sword%2C%20epic%20fantasy%20background%20with%20ancient%20Korean%20architecture%2C%20dramatic%20lighting%2C%20warm%20golden%20and%20dark%20tones&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '被背叛而死的剑术宗师，重生回到二十年前。带着前世的记忆和绝世剑术，他要向那些曾经背叛他的人一一复仇，成为真正的剑之帝王。',
    category: '动作',
    categorySlug: 'action',
    tags: ['动作', '重生', '复仇'],
    rating: 9.4,
    views: 2150000,
    status: '连载中',
    updateDate: '2026-08-03',
    chapters: [
      { id: 'ch-02-001', title: '第1话 死亡与重生', updateDate: '2026-02-10', isNew: false },
      { id: 'ch-02-002', title: '第2话 新的开始', updateDate: '2026-02-17', isNew: false },
      { id: 'ch-02-095', title: '第95话 帝王之姿', updateDate: '2026-08-03', isNew: true },
    ],
    totalChapters: 95,
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-03',
    title: '甜蜜的陷阱',
    author: '李美妍',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20illustration%20of%20a%20cute%20couple%20in%20modern%20Seoul%20cityscape%2C%20sweet%20romantic%20atmosphere%2C%20cherry%20blossom%20petals%2C%20warm%20sunset%20lighting%2C%20contemporary%20fashion%2C%20soft%20and%20dreamy%20art%20style&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '职场女强人林小夏意外与公司新来的实习生签订了一份假恋爱契约，本以为是场游戏，却不知不觉陷入了甜蜜的陷阱之中。',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '职场', '契约'],
    rating: 9.3,
    views: 980000,
    status: '连载中',
    updateDate: '2026-08-04',
    chapters: [
      { id: 'ch-03-001', title: '第1话 契约开始', updateDate: '2026-03-01', isNew: false },
      { id: 'ch-03-002', title: '第2话 假装情侣', updateDate: '2026-03-08', isNew: false },
      { id: 'ch-03-056', title: '第56话 真心流露', updateDate: '2026-08-04', isNew: true },
    ],
    totalChapters: 56,
    isHot: false,
    isNew: true,
    isRecommended: true,
  },
  {
    id: 'comic-04',
    title: '魔王的养女',
    author: '崔恩智',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20illustration%20of%20a%20young%20girl%20with%20magical%20powers%20in%20a%20dark%20fantasy%20world%2C%20mysterious%20atmosphere%2C%20floating%20magic%20particles%2C%20gothic%20castle%20silhouette%2C%20beautiful%20detailed%20art%2C%20dramatic%20contrast%20lighting&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '在大战中失去双亲的孤女被魔王收为养女，在魔界长大的她逐渐发现自己体内隐藏着足以改变世界的力量。亲情与使命的交织，让她陷入了两难。',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['奇幻', '魔法', '成长'],
    rating: 9.5,
    views: 1560000,
    status: '连载中',
    updateDate: '2026-08-05',
    chapters: [
      { id: 'ch-04-001', title: '第1话 失去的一切', updateDate: '2026-01-08', isNew: false },
      { id: 'ch-04-002', title: '第2话 魔王之城', updateDate: '2026-01-15', isNew: false },
      { id: 'ch-04-082', title: '第82话 觉醒之力', updateDate: '2026-08-05', isNew: true },
    ],
    totalChapters: 82,
    isHot: true,
    isNew: true,
    isRecommended: true,
  },
  {
    id: 'comic-05',
    title: '消失的证据',
    author: '郑允浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20illustration%20of%20a%20detective%20in%20a%20dark%20rainy%20alley%2C%20mysterious%20atmosphere%2C%20crime%20scene%20elements%2C%20dramatic%20shadows%2C%20noir%20style%2C%20cinematic%20lighting%2C%20tense%20mood&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '首尔发生连环失踪案，所有证据都指向不存在的人。刑警韩志宇在调查过程中发现，这些案件与十年前一桩被掩盖的丑闻有着千丝万缕的联系。',
    category: '悬疑',
    categorySlug: 'thriller',
    tags: ['悬疑', '推理', '犯罪'],
    rating: 9.2,
    views: 780000,
    status: '连载中',
    updateDate: '2026-08-02',
    chapters: [
      { id: 'ch-05-001', title: '第1话 失踪者', updateDate: '2026-02-20', isNew: false },
      { id: 'ch-05-002', title: '第2话 不可能的嫌疑人', updateDate: '2026-02-27', isNew: false },
      { id: 'ch-05-045', title: '第45话 真相浮现', updateDate: '2026-08-02', isNew: false },
    ],
    totalChapters: 45,
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 'comic-06',
    title: '社内相亲',
    author: '朴敏英',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20office%20romance%20illustration%20of%20a%20charming%20businessman%20and%20a%20beautiful%20office%20lady%20in%20modern%20corporate%20setting%2C%20romantic%20comedy%20vibe%2C%20bright%20and%20cheerful%20atmosphere%2C%20warm%20indoor%20lighting&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '代替闺蜜去相亲的平凡女孩金多美，却发现相亲对象竟然是公司里以冷酷著称的社长！一场啼笑皆非的办公室罗曼史就此展开。',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: ['搞笑', '恋爱', '职场'],
    rating: 9.1,
    views: 1890000,
    status: '已完结',
    updateDate: '2026-07-15',
    chapters: [
      { id: 'ch-06-001', title: '第1话 代替相亲', updateDate: '2025-06-01', isNew: false },
      { id: 'ch-06-002', title: '第2话 社长的真面目', updateDate: '2025-06-08', isNew: false },
      { id: 'ch-06-120', title: '第120话 我们的故事（完）', updateDate: '2026-07-15', isNew: false },
    ],
    totalChapters: 120,
    isHot: true,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 'comic-07',
    title: '末日生存法则',
    author: '金泰亨',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20post%20apocalyptic%20illustration%20of%20survivors%20in%20a%20ruined%20cityscape%2C%20dramatic%20action%20scene%2C%20dark%20and%20gritty%20atmosphere%2C%20survival%20theme%2C%20detailed%20ruins%20background%2C%20intense%20mood&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '一夜之间世界陷入末日，丧尸横行。普通上班族李贤宇必须在这残酷的新世界中保护家人、寻找生存之道。人性的考验比丧尸更可怕。',
    category: '动作',
    categorySlug: 'action',
    tags: ['动作', '末日', '生存'],
    rating: 9.4,
    views: 1670000,
    status: '连载中',
    updateDate: '2026-08-04',
    chapters: [
      { id: 'ch-07-001', title: '第1话 末日降临', updateDate: '2026-01-20', isNew: false },
      { id: 'ch-07-002', title: '第2话 逃出首尔', updateDate: '2026-01-27', isNew: false },
      { id: 'ch-07-067', title: '第67话 希望之城', updateDate: '2026-08-04', isNew: true },
    ],
    totalChapters: 67,
    isHot: true,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 'comic-08',
    title: '月光下的约定',
    author: '尹智秀',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20romance%20illustration%20of%20a%20couple%20in%20traditional%20hanbok%20under%20moonlight%2C%20ancient%20Korean%20palace%20garden%2C%20romantic%20and%20elegant%20atmosphere%2C%20soft%20silver%20moonlight%2C%20beautiful%20detailed%20art&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '朝鲜时代，贵族小姐与平民画师之间超越阶级的爱情故事。在月光下许下的约定，能否跨越重重阻碍实现？一部唯美动人的古风爱情故事。',
    category: '古风',
    categorySlug: 'historical',
    tags: ['古风', '恋爱', '历史'],
    rating: 9.7,
    views: 1350000,
    status: '已完结',
    updateDate: '2026-06-20',
    chapters: [
      { id: 'ch-08-001', title: '第1话 月下初遇', updateDate: '2025-08-01', isNew: false },
      { id: 'ch-08-002', title: '第2话 画中之人', updateDate: '2025-08-08', isNew: false },
      { id: 'ch-08-098', title: '第98话 永恒的约定（完）', updateDate: '2026-06-20', isNew: false },
    ],
    totalChapters: 98,
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-09',
    title: '都市夜行人',
    author: '张贤硕',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20urban%20noir%20illustration%20of%20a%20mysterious%20man%20in%20a%20trench%20coat%20on%20neon%20lit%20Seoul%20streets%20at%20night%2C%20cyberpunk%20aesthetic%2C%20rainy%20atmosphere%2C%20colorful%20neon%20reflections%2C%20stylish%20and%20cool%20vibe&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '白天是普通上班族，夜晚则化身都市义警。朴振宇的双面人生在遇到一位同样隐藏身份的神秘女子后，开始走向无法预料的危险境地。',
    category: '都市',
    categorySlug: 'urban',
    tags: ['都市', '动作', '悬疑'],
    rating: 9.0,
    views: 890000,
    status: '连载中',
    updateDate: '2026-08-01',
    chapters: [
      { id: 'ch-09-001', title: '第1话 双面人生', updateDate: '2026-03-10', isNew: false },
      { id: 'ch-09-002', title: '第2话 黑夜的正义', updateDate: '2026-03-17', isNew: false },
      { id: 'ch-09-038', title: '第38话 身份暴露', updateDate: '2026-08-01', isNew: false },
    ],
    totalChapters: 38,
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 'comic-10',
    title: '异世界的美食家',
    author: '赵恩书',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20comedy%20illustration%20of%20a%20cheerful%20chef%20in%20a%20magical%20fantasy%20kitchen%20with%20fantastical%20ingredients%2C%20colorful%20and%20whimsical%20atmosphere%2C%20delicious%20food%20illustrations%2C%20bright%20and%20fun%20art%20style&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '米其林三星主厨意外穿越到剑与魔法的异世界，用精湛厨艺征服奇幻生物的味蕾。美食即是力量——在这个世界里，一道好菜比任何魔法都强大！',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: ['搞笑', '奇幻', '美食'],
    rating: 9.3,
    views: 1120000,
    status: '连载中',
    updateDate: '2026-08-05',
    chapters: [
      { id: 'ch-10-001', title: '第1话 穿越异世界', updateDate: '2026-02-01', isNew: false },
      { id: 'ch-10-002', title: '第2话 龙的味蕾', updateDate: '2026-02-08', isNew: false },
      { id: 'ch-10-055', title: '第55话 传说中的食材', updateDate: '2026-08-05', isNew: true },
    ],
    totalChapters: 55,
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 'comic-11',
    title: '重生之商业帝国',
    author: '吴成民',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20business%20drama%20illustration%20of%20a%20confident%20businessman%20in%20a%20luxurious%20modern%20office%20with%20cityscape%20view%2C%20success%20theme%2C%20sophisticated%20atmosphere%2C%20warm%20golden%20hour%20lighting&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '被合作伙伴背叛而破产的企业家，重生回到大学时代。凭借前世积累的商业智慧和未来记忆，他从零开始打造属于自己的商业帝国，并让那些背叛者付出代价。',
    category: '剧情',
    categorySlug: 'drama',
    tags: ['剧情', '重生', '商战'],
    rating: 9.5,
    views: 1430000,
    status: '连载中',
    updateDate: '2026-08-03',
    chapters: [
      { id: 'ch-11-001', title: '第1话 背叛与重生', updateDate: '2026-01-05', isNew: false },
      { id: 'ch-11-002', title: '第2话 新的起点', updateDate: '2026-01-12', isNew: false },
      { id: 'ch-11-088', title: '第88话 帝国崛起', updateDate: '2026-08-03', isNew: false },
    ],
    totalChapters: 88,
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-12',
    title: '闺蜜的秘密',
    author: '韩素希',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20illustration%20of%20two%20women%20with%20complex%20expressions%20in%20a%20stylish%20cafe%2C%20tense%20atmosphere%2C%20friendship%20and%20betrayal%20theme%2C%20modern%20setting%2C%20subtle%20dramatic%20lighting&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '十年的闺蜜情谊，因为一个男人而岌岌可危。当郑秀雅发现闺蜜背着她与自己的未婚夫来往时，一场关于友情、爱情与背叛的故事悄然展开。',
    category: '剧情',
    categorySlug: 'drama',
    tags: ['剧情', '友情', '背叛'],
    rating: 9.1,
    views: 760000,
    status: '连载中',
    updateDate: '2026-08-02',
    chapters: [
      { id: 'ch-12-001', title: '第1话 完美的生活', updateDate: '2026-03-15', isNew: false },
      { id: 'ch-12-002', title: '第2话 裂缝', updateDate: '2026-03-22', isNew: false },
      { id: 'ch-12-042', title: '第42话 真相', updateDate: '2026-08-02', isNew: false },
    ],
    totalChapters: 42,
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 'comic-13',
    title: '九尾狐传',
    author: '金秀贤',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20illustration%20of%20a%20mystical%20nine%20tailed%20fox%20spirit%20in%20human%20form%2C%20beautiful%20ethereal%20woman%20with%20fox%20features%2C%20traditional%20Korean%20mythological%20elements%2C%20mystical%20forest%20background%2C%20magical%20atmosphere&width=600&height=800&seq=comic-cover-13&orientation=portrait',
    description: '活了千年的九尾狐为了成为真正的人类，必须在人间找到真心爱她的人。然而当她终于遇到那个人时，却发现两人之间有着跨越千年的宿命纠葛。',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['奇幻', '恋爱', '神话'],
    rating: 9.6,
    views: 1780000,
    status: '连载中',
    updateDate: '2026-08-04',
    chapters: [
      { id: 'ch-13-001', title: '第1话 千年之约', updateDate: '2026-01-10', isNew: false },
      { id: 'ch-13-002', title: '第2话 人间之旅', updateDate: '2026-01-17', isNew: false },
      { id: 'ch-13-072', title: '第72话 宿命之轮', updateDate: '2026-08-04', isNew: true },
    ],
    totalChapters: 72,
    isHot: true,
    isNew: true,
    isRecommended: true,
  },
  {
    id: 'comic-14',
    title: '杀手也有假期',
    author: '柳承范',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20comedy%20illustration%20of%20a%20cool%20assassin%20relaxing%20on%20a%20tropical%20beach%20with%20hidden%20weapons%2C%20humorous%20contrast%2C%20bright%20sunny%20atmosphere%2C%20action%20comedy%20vibe&width=600&height=800&seq=comic-cover-14&orientation=portrait',
    description: '顶级杀手金在赫决定给自己放个长假，却不想在度假地遇到了一连串意想不到的事件。想休息？先问问那些不长眼的家伙同不同意！',
    category: '动作',
    categorySlug: 'action',
    tags: ['动作', '搞笑', '杀手'],
    rating: 9.2,
    views: 1050000,
    status: '连载中',
    updateDate: '2026-08-01',
    chapters: [
      { id: 'ch-14-001', title: '第1话 杀手去度假', updateDate: '2026-04-01', isNew: false },
      { id: 'ch-14-002', title: '第2话 不平静的海滩', updateDate: '2026-04-08', isNew: false },
      { id: 'ch-14-035', title: '第35话 假期结束', updateDate: '2026-08-01', isNew: false },
    ],
    totalChapters: 35,
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 'comic-15',
    title: '第七个夜晚',
    author: '林智慧',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20thriller%20illustration%20of%20a%20woman%20looking%20fearful%20in%20a%20dark%20room%20with%20a%20countdown%20clock%2C%20psychological%20thriller%20atmosphere%2C%20dark%20and%20tense%20mood%2C%20cinematic%20horror%20lighting&width=600&height=800&seq=comic-cover-15&orientation=portrait',
    description: '连续六天晚上都做着同一个噩梦的心理咨询师，在第七个夜晚发现梦中的场景竟然在现实中一一上演。时间不多了，她必须在噩梦成真之前找出真相。',
    category: '悬疑',
    categorySlug: 'thriller',
    tags: ['悬疑', '心理', '惊悚'],
    rating: 9.3,
    views: 920000,
    status: '连载中',
    updateDate: '2026-08-05',
    chapters: [
      { id: 'ch-15-001', title: '第1话 噩梦的开始', updateDate: '2026-02-15', isNew: false },
      { id: 'ch-15-002', title: '第2话 梦与现实', updateDate: '2026-02-22', isNew: false },
      { id: 'ch-15-048', title: '第48话 第七夜', updateDate: '2026-08-05', isNew: true },
    ],
    totalChapters: 48,
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 'comic-16',
    title: '世子不见了',
    author: '姜东元',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20mystery%20illustration%20of%20a%20missing%20crown%20prince%20theme%20in%20ancient%20Korean%20palace%2C%20traditional%20architecture%2C%20mysterious%20atmosphere%2C%20royal%20court%20intrigue%2C%20dramatic%20shadows&width=600&height=800&seq=comic-cover-16&orientation=portrait',
    description: '朝鲜王朝的世子离奇失踪，整个王宫陷入混乱。一位不起眼的内侍奉命暗中调查，却揭开了一个足以颠覆王朝的巨大阴谋。',
    category: '古风',
    categorySlug: 'historical',
    tags: ['古风', '悬疑', '宫廷'],
    rating: 9.4,
    views: 1100000,
    status: '连载中',
    updateDate: '2026-08-02',
    chapters: [
      { id: 'ch-16-001', title: '第1话 世子失踪', updateDate: '2026-02-05', isNew: false },
      { id: 'ch-16-002', title: '第2话 暗中调查', updateDate: '2026-02-12', isNew: false },
      { id: 'ch-16-051', title: '第51话 宫廷阴谋', updateDate: '2026-08-02', isNew: false },
    ],
    totalChapters: 51,
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 'comic-17',
    title: '我的ID是江南美人',
    author: '朴宝英',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20college%20romance%20illustration%20of%20a%20beautiful%20female%20student%20on%20a%20university%20campus%2C%20spring%20cherry%20blossoms%2C%20youthful%20and%20fresh%20atmosphere%2C%20romantic%20comedy%20vibe%2C%20bright%20daylight&width=600&height=800&seq=comic-cover-17&orientation=portrait',
    description: '通过整容获得新生的女孩进入大学，本想低调度过校园生活，却因为出众的外貌被推到了风口浪尖。更麻烦的是，那个知道她过去的男生也在这所大学。',
    category: '都市',
    categorySlug: 'urban',
    tags: ['都市', '恋爱', '校园'],
    rating: 9.0,
    views: 2020000,
    status: '已完结',
    updateDate: '2026-05-30',
    chapters: [
      { id: 'ch-17-001', title: '第1话 新的开始', updateDate: '2025-09-01', isNew: false },
      { id: 'ch-17-002', title: '第2话 校园第一天', updateDate: '2025-09-08', isNew: false },
      { id: 'ch-17-110', title: '第110话 真正的美（完）', updateDate: '2026-05-30', isNew: false },
    ],
    totalChapters: 110,
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-18',
    title: '超能力补习班',
    author: '安宰贤',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20superpower%20school%20comedy%20illustration%20of%20students%20with%20various%20superpowers%20in%20a%20classroom%2C%20colorful%20and%20dynamic%2C%20fun%20and%20energetic%20atmosphere%2C%20action%20comedy%20style&width=600&height=800&seq=comic-cover-18&orientation=portrait',
    description: '在一所专门培养超能力者的补习班里，一群拥有各种奇葩超能力的学生为了通过超能力等级考试而努力学习。爆笑又热血的校园奇幻喜剧！',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: ['搞笑', '奇幻', '校园'],
    rating: 9.1,
    views: 870000,
    status: '连载中',
    updateDate: '2026-08-03',
    chapters: [
      { id: 'ch-18-001', title: '第1话 入学考试', updateDate: '2026-03-20', isNew: false },
      { id: 'ch-18-002', title: '第2话 奇葩同学们', updateDate: '2026-03-27', isNew: false },
      { id: 'ch-18-040', title: '第40话 等级测试', updateDate: '2026-08-03', isNew: false },
    ],
    totalChapters: 40,
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 'comic-19',
    title: '深渊之花',
    author: '宋慧乔',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20tragic%20romance%20illustration%20of%20a%20woman%20surrounded%20by%20dark%20flowers%2C%20melancholic%20beauty%2C%20dark%20romantic%20atmosphere%2C%20gothic%20elements%2C%20dramatic%20chiaroscuro%20lighting&width=600&height=800&seq=comic-cover-19&orientation=portrait',
    description: '被诅咒的贵族小姐身上长出了不能触碰任何人的深渊之花，孤独地生活在城堡中。直到一个盲眼骑士的到来，打破了诅咒的平衡。',
    category: '剧情',
    categorySlug: 'drama',
    tags: ['剧情', '恋爱', '黑暗'],
    rating: 9.5,
    views: 990000,
    status: '连载中',
    updateDate: '2026-08-04',
    chapters: [
      { id: 'ch-19-001', title: '第1话 诅咒之花', updateDate: '2026-01-25', isNew: false },
      { id: 'ch-19-002', title: '第2话 盲眼骑士', updateDate: '2026-02-01', isNew: false },
      { id: 'ch-19-060', title: '第60话 触碰', updateDate: '2026-08-04', isNew: true },
    ],
    totalChapters: 60,
    isHot: false,
    isNew: true,
    isRecommended: true,
  },
  {
    id: 'comic-20',
    title: '金牌律师',
    author: '权相宇',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20legal%20drama%20illustration%20of%20a%20confident%20lawyer%20in%20a%20courtroom%2C%20professional%20and%20sharp%20atmosphere%2C%20dramatic%20lighting%2C%20modern%20legal%20setting&width=600&height=800&seq=comic-cover-20&orientation=portrait',
    description: '胜诉率百分之百的金牌律师崔江宇，在一次案件中发现自己正在为真正的罪犯辩护。良心的谴责让他做出了一个改变一生的决定——站在正义的一边。',
    category: '剧情',
    categorySlug: 'drama',
    tags: ['剧情', '法律', '正义'],
    rating: 9.2,
    views: 830000,
    status: '连载中',
    updateDate: '2026-08-01',
    chapters: [
      { id: 'ch-20-001', title: '第1话 不败神话', updateDate: '2026-03-05', isNew: false },
      { id: 'ch-20-002', title: '第2话 良心发现', updateDate: '2026-03-12', isNew: false },
      { id: 'ch-20-036', title: '第36话 正义之战', updateDate: '2026-08-01', isNew: false },
    ],
    totalChapters: 36,
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
];

export const siteInfo = {
  name: '韩漫画网',
  tagline: '下拉式完整版韩漫免费阅读',
  description: '韩漫画网是国内领先的韩国漫画免费阅读平台，提供下拉式完整版韩漫免费阅读和无删减漫画免费阅读服务。韩漫大全每日更新，涵盖恋爱、奇幻、动作、剧情、悬疑、搞笑、都市、古风等多种类型，为您带来极致的韩漫阅读体验。',
  established: '2019年',
  email: 'contact@hanmanhua.com',
  phone: '400-888-6666',
  address: '中国上海市浦东新区张江高科技园区',
  stats: {
    totalComics: '2000+',
    dailyUpdate: '50+',
    registeredUsers: '500万+',
    dailyActiveUsers: '80万+',
  },
  features: [
    {
      title: '海量韩漫资源',
      description: '收录超过2000部韩国漫画，涵盖恋爱、奇幻、动作、剧情、悬疑等全品类，韩漫大全持续更新，总有新书可看。',
      icon: 'ri-book-open-line',
    },
    {
      title: '下拉式完整版阅读',
      description: '采用下拉式阅读模式，无需翻页即可流畅阅读完整版韩漫，带来沉浸式的阅读体验。',
      icon: 'ri-article-line',
    },
    {
      title: '无删减原版内容',
      description: '所有韩漫均为无删减版本，保留原汁原味的韩国漫画内容，让您尽情享受原作者的精湛笔触。',
      icon: 'ri-shield-check-line',
    },
    {
      title: '每日更新追更',
      description: '每日更新50+部韩漫，热门连载同步韩国更新进度，确保您第一时间看到最新章节。',
      icon: 'ri-refresh-line',
    },
  ],
  faqs: [
    {
      question: '韩漫画网的漫画是免费的吗？',
      answer: '是的，韩漫画网所有漫画均为免费阅读。我们提供下拉式完整版韩漫免费阅读服务，无需付费即可享受完整的阅读体验。',
    },
    {
      question: '漫画多久更新一次？',
      answer: '韩漫画网每日更新50部以上韩漫，热门连载漫画通常每周更新一到两话，与韩国原作保持同步更新进度。',
    },
    {
      question: '支持哪些设备阅读？',
      answer: '韩漫画网支持电脑、平板、手机等多种设备访问，采用响应式设计，在不同屏幕尺寸下都能提供舒适的阅读体验。',
    },
    {
      question: '漫画是否有删减？',
      answer: '韩漫画网提供的所有漫画均为无删减版本，我们尊重原作者的创作，确保读者能够看到最完整的漫画内容。',
    },
    {
      question: '如何找到我想看的漫画？',
      answer: '您可以通过首页的分类导航浏览不同类别的漫画，也可以使用搜索功能（即将上线）直接查找您感兴趣的漫画作品。',
    },
  ],
};